/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upcoming_Releasedate1Inputs */

const id_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis`)
};

const ms_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran`)
};

const da_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivelsesdato`)
};

const de_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsdatum`)
};

const en_us2_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const es_es2_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const es_mx2_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento`)
};

const fil_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Release`)
};

const fr_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie`)
};

const it_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di uscita`)
};

const hu_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelenés dátuma`)
};

const nl_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const no_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgivelsesdato`)
};

const pl_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data wydania`)
};

const pt_br2_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const pt_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento`)
};

const ro_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării`)
};

const fi_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaisupäivä`)
};

const sv_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Releasedatum`)
};

const vi_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành`)
};

const tr_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış Tarihi`)
};

const cs_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání`)
};

const bg_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване`)
};

const ru_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода`)
};

const uk_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу`)
};

const ar_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإصدار`)
};

const hi_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ तारीख़`)
};

const th_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย`)
};

const ja_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース日`)
};

const zh_cn2_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const zh_hant1_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

const ko_components_upcoming_releasedate1 = /** @type {(inputs: Components_Upcoming_Releasedate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release Date`)
};

/**
* | output |
* | --- |
* | "Release Date" |
*
* @param {Components_Upcoming_Releasedate1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_upcoming_releasedate1 = /** @type {((inputs?: Components_Upcoming_Releasedate1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upcoming_Releasedate1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_upcoming_releasedate1(inputs)
	if (locale === "ms") return ms_components_upcoming_releasedate1(inputs)
	if (locale === "da") return da_components_upcoming_releasedate1(inputs)
	if (locale === "de") return de_components_upcoming_releasedate1(inputs)
	if (locale === "en-US") return en_us2_components_upcoming_releasedate1(inputs)
	if (locale === "es-ES") return es_es2_components_upcoming_releasedate1(inputs)
	if (locale === "es-MX") return es_mx2_components_upcoming_releasedate1(inputs)
	if (locale === "fil") return fil_components_upcoming_releasedate1(inputs)
	if (locale === "fr") return fr_components_upcoming_releasedate1(inputs)
	if (locale === "it") return it_components_upcoming_releasedate1(inputs)
	if (locale === "hu") return hu_components_upcoming_releasedate1(inputs)
	if (locale === "nl") return nl_components_upcoming_releasedate1(inputs)
	if (locale === "no") return no_components_upcoming_releasedate1(inputs)
	if (locale === "pl") return pl_components_upcoming_releasedate1(inputs)
	if (locale === "pt-BR") return pt_br2_components_upcoming_releasedate1(inputs)
	if (locale === "pt") return pt_components_upcoming_releasedate1(inputs)
	if (locale === "ro") return ro_components_upcoming_releasedate1(inputs)
	if (locale === "fi") return fi_components_upcoming_releasedate1(inputs)
	if (locale === "sv") return sv_components_upcoming_releasedate1(inputs)
	if (locale === "vi") return vi_components_upcoming_releasedate1(inputs)
	if (locale === "tr") return tr_components_upcoming_releasedate1(inputs)
	if (locale === "cs") return cs_components_upcoming_releasedate1(inputs)
	if (locale === "bg") return bg_components_upcoming_releasedate1(inputs)
	if (locale === "ru") return ru_components_upcoming_releasedate1(inputs)
	if (locale === "uk") return uk_components_upcoming_releasedate1(inputs)
	if (locale === "ar") return ar_components_upcoming_releasedate1(inputs)
	if (locale === "hi") return hi_components_upcoming_releasedate1(inputs)
	if (locale === "th") return th_components_upcoming_releasedate1(inputs)
	if (locale === "ja") return ja_components_upcoming_releasedate1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_upcoming_releasedate1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_upcoming_releasedate1(inputs)
	return ko_components_upcoming_releasedate1(inputs)
});
export { components_upcoming_releasedate1 as "components.upcoming.releaseDate" }